import { Link } from 'react-router-dom';

import { TdcLogoPlaceholder } from '@/components/brand/tdc-logo-placeholder';
import {
  TDC_CHARITY_STATEMENT,
  TDC_CONTACT_EMAIL,
  TDC_CONTACT_MAILTO,
  TDC_HOME_URL
} from '@/lib/external-links';
import { primaryNavigation, utilityNavigation } from '@/lib/navigation';

const footerLinks = [
  ...primaryNavigation.filter((item) => item.to && item.to !== '/'),
  ...utilityNavigation
];

export function SiteFooter() {
  return (
    <footer className="border-border relative z-10 mt-auto border-t bg-card">
      <div className="mx-auto grid w-full max-w-7xl gap-10 px-4 py-12 sm:px-6 lg:grid-cols-[1.2fr_1fr] lg:px-8">
        <div className="space-y-4">
          <div className="flex flex-wrap items-center gap-3">
            <a
              href={TDC_HOME_URL}
              target="_blank"
              rel="noreferrer noopener"
              className="focus-visible:ring-ring inline-flex rounded-md focus-visible:ring-2 focus-visible:outline-none"
            >
              <TdcLogoPlaceholder size="md" />
              <span className="sr-only">(opens in a new tab)</span>
            </a>
            <div>
              <p className="font-display text-foreground text-sm font-semibold">
                NextOnVera
              </p>
              <p className="text-muted-foreground text-xs">Proudly supported by Tour de Cure</p>
            </div>
          </div>
          <p className="text-muted-foreground max-w-md text-sm leading-relaxed">
            NextOnVera funds technology-driven research and patient support to break a
            multi-decade stall in brain cancer survival.
          </p>
          <p className="text-muted-foreground text-xs leading-relaxed">{TDC_CHARITY_STATEMENT}</p>
        </div>

        <div className="grid gap-8 sm:grid-cols-2">
          <div>
            <p className="font-display text-foreground mb-3 text-xs font-semibold tracking-wide uppercase">
              Explore
            </p>
            <ul className="space-y-2">
              {footerLinks.map((item) =>
                item.to ? (
                  <li key={item.title}>
                    <Link
                      to={item.to}
                      className="text-muted-foreground hover:text-foreground focus-visible:ring-ring text-sm transition-colors focus-visible:ring-2 focus-visible:outline-none"
                    >
                      {item.title}
                    </Link>
                  </li>
                ) : null
              )}
            </ul>
          </div>
          <div>
            <p className="font-display text-foreground mb-3 text-xs font-semibold tracking-wide uppercase">
              Legal
            </p>
            <ul className="space-y-2">
              <li>
                <span className="text-muted-foreground text-sm">Privacy Policy (placeholder)</span>
              </li>
              <li>
                <a
                  href={TDC_CONTACT_MAILTO}
                  className="text-muted-foreground hover:text-foreground focus-visible:ring-ring text-sm transition-colors focus-visible:ring-2 focus-visible:outline-none"
                >
                  {TDC_CONTACT_EMAIL}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-border border-t">
        <div className="text-muted-foreground mx-auto flex w-full max-w-7xl flex-col gap-2 px-4 py-4 text-xs sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8">
          <p>© {new Date().getFullYear()} Tour De Cure · NextOnVera</p>
          <p>Built and powered by Circlet T Industries</p>
          <p>Proudly supported by Tour de Cure</p>
        </div>
      </div>
    </footer>
  );
}
